import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
const ASSET_TYPE_TO_ASSET_TYPE_ID = {
  MARKETING_EMAIL: '0-29',
  LANDING_PAGE: '0-25',
  BLOG_POST: '0-39',
  CALL: '0-48',
  CASE_STUDY: '0-161',
  CTA: '0-42',
  EMAIL: '0-49',
  FORM: '0-28',
  KNOWLEDGE_ARTICLE: '0-151',
  MARKETING_EVENT: '0-54',
  MARKETING_SMS: '0-124',
  MEDIA: '0-57',
  Media: '0-57',
  MEETING_EVENT: '0-47',
  PODCAST_EPISODE: '0-163',
  SCHEDULING_PAGE: '0-121',
  SEQUENCE: '0-58',
  SITE_PAGE: '0-38',
  SOCIAL_POST: '0-37',
  WEB_INTERACTIVE: '0-91',
  SALES_DOCUMENT: '0-83',
  PLAYBOOK: '0-96',
  AD_CAMPAIGN: '0-31',
  FEEDBACK_SURVEY: '0-111',
  TICKET: '0-5',
  LEAD: '0-136',
  WHATSAPP: '0-142'
};
const ONE_TO_MANY_GATES = {
  '0-29': gate('StudioMeasure:OneToMany:MarketingEmail'),
  '0-25': gate('StudioMeasure:OneToMany:LandingPage'),
  '0-39': gate('StudioMeasure:OneToMany:BlogPost'),
  '0-48': gate('StudioMeasure:OneToMany:Call'),
  '0-161': gate('StudioMeasure:OneToMany:CaseStudy'),
  '0-42': gate('StudioMeasure:OneToMany:CTA'),
  '0-49': gate('StudioMeasure:OneToMany:Email'),
  '0-28': gate('StudioMeasure:OneToMany:Form'),
  '0-151': gate('StudioMeasure:OneToMany:KnowledgeArticle'),
  '0-54': gate('StudioMeasure:OneToMany:MarketingEvent'),
  '0-124': gate('StudioMeasure:OneToMany:MarketingSMS'),
  '0-57': gate('StudioMeasure:OneToMany:Media'),
  '0-47': gate('StudioMeasure:OneToMany:MeetingEvent'),
  '0-163': gate('StudioMeasure:OneToMany:PodcastEpisode'),
  '0-58': gate('StudioMeasure:OneToMany:Sequence'),
  '0-38': gate('StudioMeasure:OneToMany:SitePage'),
  '0-37': gate('StudioMeasure:OneToMany:SocialPost'),
  '0-91': gate('StudioMeasure:OneToMany:WebInteractive'),
  '0-121': gate('StudioMeasure:OneToMany:MeetingEvent'),
  '0-83': gate('StudioMeasure:OneToMany:SalesDocument'),
  '0-96': gate('StudioMeasure:OneToMany:Playbook'),
  '0-31': gate('StudioMeasure:OneToMany:AdCampaign'),
  '0-111': gate('StudioMeasure:OneToMany:FeedbackSurvey'),
  '0-5': gate('StudioMeasure:OneToMany:Ticket'),
  '0-136': gate('CampaignsLeadsAssociationGate')
};
export const getIsUngatedForPerformanceRollup = () => {
  try {
    const {
      gates
    } = userInfoSync();
    if (gates.includes(gate('StudioMeasure:PerformanceRollup'))) {
      return true;
    }
    if (gates.includes(gate('StudioMeasure:PerformanceRollupWithStudio')) && gates.includes(gate('GoToMarketingStudio'))) {
      return true;
    }
    return false;
  } catch (__) {
    return false;
  }
};
export const getIsUngatedForOneToMany = (assetTypeOrId, checker) => {
  if (!assetTypeOrId) return false;
  const gateName = ONE_TO_MANY_GATES[assetTypeOrId] || ONE_TO_MANY_GATES[ASSET_TYPE_TO_ASSET_TYPE_ID[assetTypeOrId]];
  if (gateName && checker) {
    return checker(gateName);
  }
  return false;
};
export const getIsUngatedForCampaignsSelectV2 = () => {
  try {
    return userInfoSync().gates.includes(gate('MarketingStudio::CampaignsSelectV2'));
  } catch (_unused) {
    return false;
  }
};
export const getIsAssetUngatedForOneToMany = assetTypeOrId => {
  if (assetTypeOrId === 'WHATSAPP' || assetTypeOrId === '0-142') {
    return true;
  }
  try {
    return getIsUngatedForOneToMany(assetTypeOrId, gateName => userInfoSync().gates.includes(gateName));
  } catch (_unused2) {
    return false;
  }
};